import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Send, ArrowRight, Loader2 } from 'lucide-react';
import { useLang } from '../context/LangContext';
import { cmsApi } from '../api/requests';

export default function CustomOrderSuccess() {
  const [cms, setCms] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useLang();

  useEffect(() => {
    cmsApi.getSection('customOrder').then(r => setCms(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const sp = cms?.successPage || {};

  if (loading) {
    return <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center"><Loader2 className="w-8 h-8 text-indigo-400 animate-spin" /></div>;
  }

  return (
    <div data-testid="custom-order-success-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 pt-24">
      <div className="max-w-lg w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-500/20 rounded-full mb-8">
          <CheckCircle className="w-10 h-10 text-emerald-400" />
        </div>
        <h1 className="text-3xl font-['Outfit'] font-medium text-white mb-4">{sp.title || t('success.title')}</h1>
        <p className="text-zinc-400 mb-8">{sp.message || t('success.subtitle')}</p>
        {sp.nextStepsTitle && (
          <div className="p-6 bg-indigo-500/10 border border-indigo-500/20 rounded-xl mb-8">
            <div className="flex items-center justify-center space-x-3 text-indigo-400 mb-2">
              <Send className="w-5 h-5" /><span className="font-medium">{sp.nextStepsTitle}</span>
            </div>
            <p className="text-zinc-400 text-sm">{sp.nextStepsMessage}</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/catalog" data-testid="browse-collection-btn"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-lg transition-colors">
            <span>{sp.browseButtonText || t('nav.browseCollection')}</span><ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/" className="text-zinc-400 hover:text-white transition-colors">{t('success.backHome')}</Link>
        </div>
      </div>
    </div>
  );
}
